export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-user-star-line',
      title: 'Customized Financial Solutions',
      description: 'We offer personalized plans tailored to meet your unique retirement, business, and family financial goals.',
      color: 'teal'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Expert Guidance',
      description: 'Our team of experienced professionals provides trusted advice to help you make informed financial decisions.',
      color: 'slate'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Comprehensive Services',
      description: 'From retirement planning to business benefits, we cover all aspects of financial security under one roof.',
      color: 'blue'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Why Choose <span className="text-teal-600">Advanced Benefit Designs</span>?
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            With over 25 years of expertise, we deliver innovative solutions that drive results and build lasting partnerships.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-2xl transition-all duration-300 border border-slate-100 hover:border-teal-200 hover:-translate-y-2"
            >
              <div className="mb-6">
                <div className={`w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br from-${reason.color}-500 to-${reason.color}-600 text-white shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${reason.icon} text-3xl`}></i>
                </div>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{reason.title}</h3>
              <p className="text-slate-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
